import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import { css } from 'styled-system/css';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import { Box } from 'styled-system/jsx';
import useIncidentDetailsInitial from '@/modules/adjusterReportModules/IncidentDetails/pages/initialVisitDetails/incidentDetailsInitial.biz';
import IncidentDetailMainDetailCard from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/incidentDetailMainDetailCard';

const InitialVisitDetails = () => {
  return (
    <MainLayout header="titleHeader" title="مشخصات بازدید" hasBottomPadding>
      <InitialVisitDetailsPage />
    </MainLayout>
  );
};

export default InitialVisitDetails;

const InitialVisitDetailsPage = () => {
  const { incidentDetailsInitialData, incidentDetailsPending } =
    useIncidentDetailsInitial();
  if (incidentDetailsPending) return <LoadingPage />;
  return (
    <>
      <Box className={css({ marginTop: '6rem' })}>
        <IncidentDetailMainDetailCard
          fileNumber={incidentDetailsInitialData?.order_id!}
          fileType={incidentDetailsInitialData?.file_type.const!}
          svgColor="colors.blue"
          items={incidentDetailsInitialData?.detailCardItems!}
          hasBullet={true}
          backgroundColor="blue-1"
          headerClassName={css({ borderColor: 'blue-1' })}
        />
      </Box>
    </>
  );
};
